import { Stack } from '../../../../design-system/stack/stack';
import { InvoiceIntakeCard } from './invoice-intake-card';

type EmptyStateDisconnectedEmailProps = {
  onConnectGmail: () => void;
};

export const EmptyStateDisconnectedEmail = ({ onConnectGmail }: EmptyStateDisconnectedEmailProps) => {
  return (
    <Stack space={6} align="stretch" className="mt-5">
      <Stack space={2} align="stretch">
        <h2 className="text-xl leading-6 font-medium tracking-tight text-black">Introducing Invoice Pay</h2>

        <p className="text-base font-medium tracking-tight text-muted-foreground">
          Never spend hours on the invoice run again. Connect your Gmail - we'll read the details for you and queue
          everything up for you to review and pay in just a few clicks.
        </p>
      </Stack>

      <InvoiceIntakeCard cardVariantConfig={{ variant: 'EMAIL', onEmailConnect: onConnectGmail }} />

      <p className="text-base font-medium tracking-tight text-muted-foreground">
        Seapoint will never take action without your approval. You can review and approve every invoice before it's
        paid.
      </p>
    </Stack>
  );
};
